interface PublicRuntime {
  apiUrl?: string;
  connectorUrl?: string;
  stripePublishableKey?: string;
  stripeMode?: 'test'|'live';
}
export function runtimeEnvironment(): PublicRuntime {
  const value = (globalThis as typeof globalThis & {__SCREENLEADS_PUBLIC_CONFIG__?: PublicRuntime}).__SCREENLEADS_PUBLIC_CONFIG__;
  const result: PublicRuntime = {};
  if (typeof value?.connectorUrl === 'string') result.connectorUrl=value.connectorUrl;
  if (typeof value?.apiUrl === 'string') result.apiUrl=value.apiUrl;
  if (typeof value?.stripePublishableKey === 'string' && /^pk_(test|live)_/.test(value.stripePublishableKey)) result.stripePublishableKey=value.stripePublishableKey;
  if (value?.stripeMode === 'test' || value?.stripeMode === 'live') result.stripeMode=value.stripeMode;
  return result;
}
